<template>
  <article class="page entreprise" v-if="entreprise">
    <div class="page__header">
      <router-link to="/" class="page__back">Retour</router-link>
      <img
        v-if="entreprise.featured_media"
        :src="entreprise._embedded['wp:featuredmedia']['0'].source_url"
        :alt="entreprise.title.rendered"
      />
    </div>

    <div class="page__container">
      <div class="page__container__entreprisename">
        <img
          v-if="entreprise.acf.logo_entreprise"
          :src="entreprise.acf.logo_entreprise"
          :alt="entreprise.title.rendered"
        />
        <h1 v-else v-html="entreprise.title.rendered"></h1>
        <p class="page__member-badge">Membre</p>
      </div>
      <div class="page__container__entreprisedescription">
        <div v-if="entreprise.acf.secteur_activite">
          <dt>Secteur d'activité</dt>
          <dd>{{ entreprise.acf.secteur_activite }}</dd>
        </div>
        <div v-if="entreprise.acf.sous_secteur_activite">
          <dt>Sous secteur d'activité</dt>
          <dd>{{ entreprise.acf.sous_secteur_activite }}</dd>
        </div>
        <div v-if="entreprise.acf.presentation_entreprise">
          <dt>Présentation de l’entreprise</dt>
          <dd>{{ entreprise.acf.presentation_entreprise }}</dd>
        </div>
      </div>
      <div class="page__container__entreprisetabs" v-if="tabs">
        <ul>
          <li
            :class="{ active: currentTab.name === tab.name }"
            v-for="tab in tabs"
            :key="tab.name"
            @click="currentTab = tab"
          >
            <a>{{ tab.name }}</a>
          </li>
        </ul>
        <div
          class="page__container__entreprisetabs__tabscontent"
          v-if="currentTab"
        >
          <component
            :entreprise="entreprise"
            :is="currentTab.component"
          ></component>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import TabActualites from "@/components/Tabs/TabActualites.vue";
import TabCoordonnees from "@/components/Tabs/TabCoordonnees.vue";
import TabInfosLegales from "@/components/Tabs/TabInfosLegales.vue";
export default {
  components: {
    TabActualites,
    TabCoordonnees,
    TabInfosLegales,
  },
  data() {
    return {
      slug: this.$route.params.slug,
      tabs: [],
      currentTab: null,
    };
  },
  methods: {
    initTabs() {
      this.tabs = this.infosTabs;
      this.currentTab = this.tabs[0];
    },
  },
  computed: {
    entreprise() {
      return this.$store.getters.entreprisePage;
    },
    infosTabs() {
      let tabs = [];
      // if (this.entreprise) {
      //   tabs.push({
      //     name: "Actualités",
      //     component: TabActualites,
      //   });
      // }
      if (this.entreprise) {
        tabs.push({
          name: "Coordonnées",
          component: TabCoordonnees,
        });
      }
      if (this.entreprise) {
        tabs.push({
          name: "Informations légales",
          component: TabInfosLegales,
        });
      }
      return tabs;
    },
  },
  watch: {
    entreprise() {
      this.initTabs();
      console.log(this.entreprise);
    },
  },
  created() {
    this.$store.dispatch("getEntreprise", this.slug);
  },
};
</script>

<style lang="scss" scoped>
.page {
  min-height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  z-index: 1000;
  background-color: var(--white);
  pointer-events: all;
  overflow-y: scroll;
  &__header {
    position: relative;
    height: calc(100vh / 3);
    background-color: var(--gray);
    img {
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      display: block;
      object-fit: cover;
      pointer-events: none;
    }
  }

  &__container {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 25px;
    position: absolute;
    &__entreprisename {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      gap: 20px;
      h1 {
        margin: 0;
        padding: 0;
      }
      img {
        height: auto;
        width: auto;
        max-width: 120px;
        max-height: 75px;
        margin: 0;
        padding: 0;
      }
    }
    &__entreprisedescription {
      width: 100%;
      height: auto;
      margin: 35px 0 0 0;
      padding: 0;
      div {
        width: 100%;
        margin: 0;
        padding: 12px 0;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        border: none;
        border-bottom: solid 1px var(--gray);
        dt {
          width: 50%;
          margin: 0;
          padding: 0 5px 0 0;
          display: inline-block;
          color: var(--black);
          font-size: 14px;
          font-weight: 700;
        }
        dd {
          margin: 0;
          padding: 0;
          display: inline-block;
          color: var(--black);
          font-size: 14px;
          font-weight: 400;
        }
      }
      div:last-child {
        margin-top: 35px;
        padding: 0;
        flex-direction: column;
        border: none;
        dt {
          width: 100%;
        }
        dd {
          margin-top: 20px;
        }
      }
    }
    &__entreprisetabs {
      width: 100%;
      height: auto;
      margin: 0;
      padding: 0;
      & > ul {
        margin: 35px 0;
        padding: 0;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: flex-end;
        gap: 30px;
        position: relative;
        list-style: none;
        &::after {
          content: "";
          width: 100%;
          height: 1px;
          margin: 0;
          padding: 0;
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: -1;
          background-color: #dddddd;
        }
        & > li {
          margin: 0;
          padding: 0;
          position: relative;
          &::after {
            content: "";
            width: 100%;
            height: 1px;
            margin: 0;
            padding: 0;
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 0;
            background-color: transparent;
            transform: translateY(2px);
            transition: ease 0.25s;
          }
          cursor: pointer;
          &:hover,
          &.active {
            &::after {
              content: "";
              background-color: var(--green);
              transform: translateY(0);
              transition: ease 0.25s;
            }
            a {
              color: var(--green);
              transition: ease 0.25s;
            }
          }
          & > a {
            width: 100%;
            margin: 0;
            padding: 0 0 10px 0;
            display: block;
            color: var(--black);
            font-size: 14px;
            font-weight: 700;
            text-align: center;
            transition: ease 0.25s;
          }
        }
      }
      &__tabscontent {
        width: 100%;
        height: auto;
        margin: 0;
        padding: 0;
      }
    }
  }

  &__member-badge {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    color: var(--green);
    font-size: 14px;
    font-weight: 600;
    text-align: right;
    &::before {
      content: "";
      width: 10px;
      height: 10px;
      margin: 0;
      margin-right: 5px;
      padding: 0;
      display: inline-block;
      background-image: url("../assets/images/icons/icon-star.svg");
      background-size: 10px;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }

  &__back {
    z-index: 999;
    margin: 0;
    padding: 6px 16px;
    display: block;
    position: absolute;
    top: 25px;
    left: 25px;
    color: var(--white);
    background-color: var(--black);
    border-radius: 50px;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    &::before {
      content: "";
      width: 10px;
      height: 10px;
      margin-right: 8px;
      display: inline-block;
      position: relative;
      background-image: url("../assets/images/icons/icon-arrow.svg");
      background-size: 10px;
      background-repeat: no-repeat;
      background-position: center center;
      filter: invert(1);
    }
  }
}
</style>
